import React, { useEffect } from 'react';
// components
import Title from '../../../components/Title';
import Button from '../../../components/Button';

// assets
import SelfieIndication from '../../../assets/img/SelfieIndication.png';
import { useStore } from '../../../context/appContext';
import { modalTypes } from '../../../context/types';
import useGAEventsTracker from '../../../utils/useGAEventsTrackers';
import {
  Bluespan,
  ButtonDiv,
  ContentDiv,
  DescriptionText,
  ImagePreview,
  Img,
  MainCameraDiv,
  SelfieIndicationDiv,
  SelfieText
} from './signatureStyled';
import { CAMERA_ACCESS_ERROR, NEUTRAL_SELFIE } from '../../../constants/selfieTypes';

function SignatureNeutral() {
  const {
    setModal,
    photosUri,
    setCamera,
    stepForward,
    setError,
  } = useStore();

  const constraints = { audio: false, video: { facingMode: 'environment', width: 720, height: 1080 } }
  const cameraError = { type: CAMERA_ACCESS_ERROR }

  const GAEventsTracker = useGAEventsTracker("Selfie Neutral Page");
  useEffect(() => {
    GAEventsTracker("Visualiza pantalla Selfie Neutral");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (photosUri.neutralSelfie) return;
    setModal({
      open: true,
      type: modalTypes.signatureInfo,
    });
    return () => {
      setModal({
        open: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = () => {
    if (!photosUri.neutralSelfie) return;
    photosUri.randomSelfie = Math.round(Math.random() * 1);
    GAEventsTracker("Confirma selfie neutral");
    stepForward();
  };

  const cameraPermissions = (type) => {
    setCamera({
      open: true,
      type: type,
    });
  }

  const handleOpenCamera = () => {
    cameraPermissions(NEUTRAL_SELFIE);
    // setCamera({
    //   open: true,
    //   type: NEUTRAL_SELFIE,
    // });
  };

  return (
    <>
      <Title grid="title">Firma electrónica</Title>
      <ContentDiv>
        <DescriptionText>
          ¡Muy bien! Ahora tomate una selfie para avanzar.
        </DescriptionText>
        <MainCameraDiv>
          <SelfieIndicationDiv onClick={handleOpenCamera}>
            {photosUri.neutralSelfie ? (
              <ImagePreview src={photosUri.neutralSelfie} />
            ) : (
              <>
                <Img src={SelfieIndication} />
                <SelfieText>
                  <Bluespan>Presiona áca</Bluespan> para tomar una foto de{' '}
                  <Bluespan>tu rostro</Bluespan>
                </SelfieText>
              </>
            )}
          </SelfieIndicationDiv>
        </MainCameraDiv>
      </ContentDiv>
      <ButtonDiv>
        <Button filled={!!photosUri.neutralSelfie} onClick={handleSubmit}>
          Confirmar
        </Button>
      </ButtonDiv>
    </>
  );
}

export default SignatureNeutral;
